var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.7167H14.8667C14.2 15.7167 13.5667 15.975 13.1 16.4417L11.675 17.85C11.025 18.4917 9.96668 18.4917 9.31668 17.85L7.89166 16.4417C7.425 15.975 6.78333 15.7167 6.125 15.7167H5.5C4.11667 15.7167 3 14.6084 3 13.2417V4.14169C3 2.77502 4.11667 1.66669 5.5 1.66669H15.5C16.8833 1.66669 18 2.77502 18 4.14169V13.2334C18 14.6 16.8833 15.7167 15.5 15.7167Z",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5583 7.45831C10.525 7.45831 10.475 7.45831 10.4333 7.45831C9.55831 7.42498 8.86664 6.71665 8.86664 5.83331C8.86664 4.93331 9.59165 4.20831 10.4916 4.20831C11.3916 4.20831 12.1167 4.94165 12.1167 5.83331C12.125 6.71665 11.4333 7.43331 10.5583 7.45831Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20833 9.96667C7.09999 10.7083 7.09999 11.9167 8.20833 12.6583C9.46666 13.5 11.5333 13.5 12.7917 12.6583C13.9 11.9167 13.9 10.7083 12.7917 9.96667C11.5333 9.13334 9.47499 9.13334 8.20833 9.96667Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagUser);
export default __webpack_public_path__ + "static/media/tag-user.fbd63bbd57d14c929b07e4376fc27214.svg";
export { ForwardRef as ReactComponent };